import Vue from 'vue'

export default {
  autocomplete (searchTerm) {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/vendors/autocomplete?search=${searchTerm || ''}`
    )
  }
}
